/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Test_Print_SuccessInputs */

const vi_print_admin_test_print_success = /** @type {(inputs: Print_Admin_Test_Print_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi lệnh in thử — kiểm tra máy in ở điểm bán`)
};

/**

* @param {Print_Admin_Test_Print_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_test_print_success = /** @type {((inputs?: Print_Admin_Test_Print_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Test_Print_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_test_print_success(inputs)
});